import React, { lazy, Suspense, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Loader } from '@resy/ui-kitchen';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';
import { isDevicePixelRatio2x, validateImageFileFormat } from '../../AmexMarketingUtils/AmexUtils';
import './AmexGDAB2BAboutProgram.scss';

const AmexGDAB2BAboutProgram = (
  {
    baseRequestUrl,
    aboutConfig: {
      images: {
        desktop: desktopImg = {},
        mobile: mobileImg = {},
      } = {},
      copy,
      video,
      section_id: sectionId,
      media_type: mediaType = 'image',
    },
    Analytics,
    matchMedia,
    handleVideoError,
  }
) => {
  const imgPath = `${baseRequestUrl}AmexGDAB2B/images/AboutProgram/`;
  const imageType = matchMedia.lg ? desktopImg : mobileImg;
  const imageName = isDevicePixelRatio2x() ? imageType?.retina : imageType?.regular;
  const image = validateImageFileFormat(imageName);

  const videoObj = video || {};
  if (!copy || Object.keys(videoObj).length === 0) handleVideoError(true);
  const videoPath = `${baseRequestUrl}AmexGDAB2B/AboutProgramVideo/`;
  const AmexVideo = useMemo(() => lazy(() => import('../../AmexMarketingUtils/AmexVideo')), []);
  const SuspenseWrapper = (page) => (<Suspense fallback={<Loader />}>{page}</Suspense>);

  const sanitizedCopy = sanitizeString(copy);

  return (
    <section className="AmexGDAB2BAboutProgram" id={sectionId}>
      <div className="container">
        <div className="AmexGDAB2BAboutProgram__body">
          <div className="AmexGDAB2BAboutProgram__content">
            <div
              className="AmexGDAB2BAboutProgram__text"
              dangerouslySetInnerHTML={{
                __html: sanitizedCopy,
              }}
            />
          </div>
          {(mediaType === 'video') && (
          <div className="AmexGDAB2BAboutProgram__video">
            {SuspenseWrapper(
              <AmexVideo
                baseRequestUrl={baseRequestUrl}
                Analytics={Analytics}
                matchMedia={matchMedia}
                video={video}
                videoPath={videoPath}
                handleVideoError={handleVideoError}
              />
            )}
          </div>
          )}
          {(mediaType === 'image' && matchMedia.lg) && (
            <div
              className="AmexGDAB2BAboutProgram__image"
              style={{
                backgroundImage: `url(${imgPath}${image})`,
              }}
            />
          )}
          {(mediaType === 'image' && !matchMedia.lg) && (
            <img
              className="AmexGDAB2BAboutProgram__image-mobile"
              src={`${imgPath}${image}`}
              alt="test"
            />
          )}
        </div>
      </div>
    </section>
  );
};
AmexGDAB2BAboutProgram.propTypes = {
  baseRequestUrl: PropTypes.string.isRequired,
  aboutConfig: PropTypes.shape({
    copy: PropTypes.string.isRequired,
    video: PropTypes.shape({}).isRequired,
    section_id: PropTypes.string.isRequired,
    images: PropTypes.shape({}).isRequired,
    media_type: PropTypes.string.isRequired,
  }).isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    ipadLandscape: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  handleVideoError: PropTypes.func.isRequired,
};
export default AmexGDAB2BAboutProgram;
